import React, { useContext, useEffect } from "react";
import UploadLogo from "./UploadLogo";
import { ColorContext } from "../../contexts/ColorContext";
import InputColor from "../inputs/InputColor";
import LinkLogo from "./LinkLogo";
import { LogoContext } from "../../contexts/LogoContext";

const LogoActions = ({ select }) => {
  const { dispatch } = useContext(LogoContext);
  const { colors } = useContext(ColorContext);
  useEffect(() => {
    dispatch({ type: "UPDATE_DROPDOWN", dropdown: select });
  }, [select]);
  return select === "typed" ? (
    <InputColor
      actionType="UPDATE_LOGO_COLOR"
      label="Logo Colour"
      color={colors.logoColor}
    />
  ) : select === "local" ? (
    <UploadLogo />
  ) : (
    <LinkLogo />
  );
};

export default LogoActions;
